<template>
	<div>
		<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Note" @click="onClickEditNote()" class="mr-1 no-text">
			<i class="far fa-sticky-note"></i>
		</b-button>
		<b-modal ref="mdlNoreEdit" id="mdlNoreEdit" size="lg" style="height: 100%" title="Note" @ok="onOkNote">
			<b-row>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<vue-editor class="sa-qeditor-note-component" :editor-toolbar="customToolbar" v-model="jsonData.note" />
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import UtilityMixin from "../UtilityMixin";
export default {
	props: {
		patNoteResources: {
			type: String,
			required: true,
		},
		idNota: {
			type: String,
			required: true,
		},
		notaAssociazione: {
			type: String,
		},
	},
	mixins: [UtilityMixin],
	components: { VueEditor },
	data() {
		return {
			customToolbar: [
				["bold", "italic", "underline", "strike"], // toggled buttons
				[{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
				[{ color: [] }, { background: [] }], // dropdown with defaults from theme
			],
			jsonData: { note: "" },
		};
	},
	mounted() {
		this.jsonData.note = this.notaAssociazione;
	},
	methods: {
		onClickEditNote() {
			this.$refs.mdlNoreEdit.show();
		},
		onOkNote(bvModalEvent) {
			bvModalEvent.preventDefault();
			this.salvaNota();
		},
		salvaNota() {
			let me = this;
			let body = { note: this.jsonData.note };
			let link = process.env.VUE_APP_PATH_API + me.patNoteResources + "/aggiornanota/" + this.idNota;
			me.restCallPut(link, body, me.salvaNotaSuccess, me.salvaNotaError);
		},
		salvaNotaSuccess() {
			let me = this;
			this.numeroRecordsSalvati++;
			me.$bvToast.toast("Nota salvata con succedsso ", {
				title: "Salvataggio Nota",
				variant: "success",
				solid: true,
			});
			me.$emit("afterSaveSuccess");
			me.closeModal();
		},
		salvaNotaError(error) {
			let me = this;
			this.numeroRecordsSalvati++;
			me.allSavedSuccess = false;
			me.$bvToast.toast("Errore nel salvataggio" + error.message, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
			//me.closeModal();
		},
		closeModal() {
			this.$refs.mdlNoreEdit.hide();
		},
	},
};
</script>

<style>
/* .sa-qeditor-note-component {
	background-color: transparent;
}
.sa-qeditor-note-component .ql-container {
	height: calc(100vh - 220px);
} */
</style>
